import { useEffect } from "react";
import { useSite } from "@/lib/site";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyActions from "@/components/site/StickyActions";
import MarqueeStrip from "@/components/site/MarqueeStrip";

export default function Home() {
  const { site, loading } = useSite();

  // Dynamic SEO based on site content
  useEffect(() => {
    if (!site) return;
    if (site.seo_title) document.title = site.seo_title;
    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) return;
      el.setAttribute(attr, value);
    };
    if (site.seo_description) {
      setMeta('meta[name="description"]', "content", site.seo_description);
      setMeta('meta[property="og:description"]', "content", site.seo_description);
      setMeta('meta[name="twitter:description"]', "content", site.seo_description);
    }
    if (site.seo_title) {
      setMeta('meta[property="og:title"]', "content", site.seo_title);
      setMeta('meta[name="twitter:title"]', "content", site.seo_title);
    }
    if (site.logo_url) {
      setMeta('meta[property="og:image"]', "content", site.logo_url);
      setMeta('meta[name="twitter:image"]', "content", site.logo_url);
    }
    // Google Tag injection
    if (site.google_tag_id && !document.getElementById("gtag-src")) {
      const s = document.createElement("script");
      s.id = "gtag-src";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${site.google_tag_id}`;
      document.head.appendChild(s);
      const inline = document.createElement("script");
      inline.id = "gtag-inline";
      inline.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${site.google_tag_id}');`;
      document.head.appendChild(inline);
    }
  }, [site]);

  if (loading || !site) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="tech-label">Loading…</div>
      </div>
    );
  }

  return (
    <div className="bg-black text-zinc-100">
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <About />
        <Services />
        <Gallery />
        <Contact />
      </main>
      <Footer />
      <StickyActions />
    </div>
  );
}
